import React from 'react';
import { Eyebrow } from '../ui/Eyebrow';
interface PageHeaderProps {
  eyebrow: string;
  title: string;
  intro?: string;
  aside?: React.ReactNode;
}
export function PageHeader({
  eyebrow,
  title,
  intro,
  aside
}: PageHeaderProps) {
  return <header className="bg-cream" data-id="element-196" data-mp="1mdw0mf47umwx">
      <div className="mx-auto max-w-shell px-6 pb-4 pt-14 md:px-8 md:pb-6 md:pt-20" data-id="element-197" data-mp="1r5vvht5fipmn">
        <Eyebrow className="text-brick" data-id="element-198" data-mp="1r7qidd09grtd">{eyebrow}</Eyebrow>
        <div className="mt-5 grid gap-8 lg:grid-cols-[1.2fr_0.8fr] lg:items-end lg:gap-16" data-id="element-199" data-mp="1w473dyc5yq28">
          <h1 className="max-w-3xl font-serif text-[2.75rem] leading-[1.02] text-ink md:text-[4.25rem]" data-id="element-200" data-mp="2130lk42eb58q">
            {title}
          </h1>
          {intro && <p className="max-w-xl text-base leading-relaxed text-ink-soft md:text-lg" data-id="element-201" data-mp="2a4hxda8rskrm">{intro}</p>}
        </div>
        {aside && <div className="mt-10" data-id="element-202" data-mp="bq6sxdtcb9d7">{aside}</div>}
      </div>
    </header>;
}